<template lang="html">
  <div>
    <vx-card>
      <div class="vx-row mb-10">
        <div class="vx-col md:w-1/3">
          <span class="text-sm">Período Inicial</span>
          <datepicker
            v-model="table.filters.started_at"
            name="started_at"
            placeholder="Selecione"
            :clear-button="false"
            :language="ptBR"
          />
          <vs-button class="mt-5" @click="onSearch()">Pesquisar</vs-button>
        </div>
        <div class="vx-col md:w-1/3">
          <span class="text-sm">Período Final</span>
          <datepicker
            v-model="table.filters.finished_at"
            name="finished_at"
            placeholder="Selecione"
            :clear-button="false"
            :language="ptBR"
          />
        </div>

        <div class="vx-col md:w-1/3">
          <div class="flex flex-col items-center">
            <span class="font-bold mb-2 text-sm">
              Exportar Relatório
            </span>
            <div class="flex">
              <vs-button
                color="primary"
                type="filled"
                class="ml-4"
                icon-pack="feather"
                icon="icon-download"
                size="small"
                :disabled="
                  loadingExcel || loadingPdf || totalRecords === 0
                "
                @click="() => download('pdf')"
                >{{ loadingPdf ? '' : 'PDF' }}
                <clip-loader
                  v-if="loadingPdf"
                  size="12px"
                  color="#fff"
                  class="ml-3"
                  :loading="loadingPdf"
                ></clip-loader
              ></vs-button>
              <vs-button
                color="primary"
                class="ml-4 mr-4"
                type="filled"
                size="small"
                icon-pack="feather"
                icon="icon-download"
                :disabled="
                  loadingExcel || loadingPdf || totalRecords === 0
                "
                @click="() => download('excel')"
                >{{ loadingExcel ? '' : 'EXCEL' }}
                <clip-loader
                  v-if="loadingExcel"
                  size="12px"
                  color="#fff"
                  class="ml-3"
                  :loading="loadingExcel"
                ></clip-loader
              ></vs-button>
            </div>
          </div>
        </div>
      </div>

      <vue-good-table
        mode="remote"
        :pagination-options="{
          enabled: true,
          nextLabel: 'próximo',
          prevLabel: 'anterior',
          rowsPerPageLabel: 'Registros por páginas',
          ofLabel: 'de',
          pageLabel: 'página',
          dropdownAllowAll: false,
        }"
        :total-rows="totalRecords"
        :sort-options="{
          enabled: false,
        }"
        :columns="columns"
        :rows="rows"
        :is-loading.sync="isLoading"
        @on-select-all="onSelectAll"
        @on-selected-rows-change="selectionChanged"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
      >
        <div slot="emptystate">
          <span>Nenhum resultado encontrado</span>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'credited_at'">
            <span>{{ formatDateSubHours(props.row.credited_at) }}</span>
          </span>
          <span v-if="props.column.field == 'pay_day'">
            <span>{{ formatDateSubHours(props.row.pay_day) }}</span>
          </span>
          <span v-if="props.column.field == 'person_name'">
            <span>{{ props.row.person_name || 'N/A' }}</span>
          </span>
          <span v-if="props.column.field == 'cycle_name'">
            <span>{{ props.row.cycle_name || 'N/A' }}</span>
          </span>
          <span v-if="props.column.field == 'identity'">
            <span>{{ formatIdentity(props.row.identity) || 'N/A' }}</span>
          </span>
          <span v-if="props.column.field == 'fommento_name'">
            <span>{{ props.row.fommento.name || 'N/A' }}</span>
          </span>
          <span v-if="props.column.field == 'fommento_account'">
            <span>{{ props.row.fommento.account_number || 'N/A' }}</span>
          </span>
          <span v-if="props.column.field == 'requested_amount'">
            <span>{{ formatMoney(props.row.requested_amount) }}</span>
          </span>
          <span v-if="props.column.field == 'released_amount'">
            <span>{{ formatMoney(props.row.released_amount) }}</span>
          </span>
          <span v-if="props.column.field == 'total_tax_value'">
            <span>{{ formatMoney(props.row.total_tax_value) }}</span>
          </span>
          <span v-if="props.column.field == 'whitelabel_split'">
            <span>{{ formatMoney(props.row.whitelabel_split) }}</span>
          </span>
          <span v-if="props.column.field == 'moneycloud_split'">
            <span>{{ formatMoney(props.row.moneycloud_split) }}</span>
          </span>
        </template>
      </vue-good-table>
    </vx-card>

    <div class="vx-col w-full mt-8 flex flex-row">
      <vs-button
        class="mx-1 px-8"
        color="primary"
        icon-pack="feather"
        icon="icon-arrow-left"
        @click="goBack"
      ></vs-button>
    </div>
  </div>
</template>

<script>
import { startOfDay, addDays } from "date-fns";
import { mask } from "vue-the-mask";
import Datepicker from "vuejs-datepicker";
import tableMixin from "../mixins/table";
import { ptBR } from 'vuejs-datepicker/dist/locale';
import {
  formatIdentity,
  formatMoney,
  formatDate,
  formatDateSubHours,
} from "../utils";
import { permissionRedirect } from "../utils/acl";
import {
    gerarDocPdf,
    gerarTablePdf,
    gerarDocInfo,
    salvarDocPdf,
} from '../utils/index';
import { excelGenerator } from '../utils/excelGenerator';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';

export default {
  components: { Datepicker, ClipLoader },
  directives: { mask },
  mixins: [tableMixin],
  data() {
    return {
      table: {
        filters: {
          started_at: null,
          finished_at: null,
        },
      },
      columns: [
        {
          label: "Creditado Em",
          field: "credited_at",
        },
        {
          label: "Titular",
          field: "person_name",
          filterOptions: {
            enabled: true,
            placeholder: "Pesquisar Titular",
          },
        },
        {
          label: "CPF / CNPJ",
          field: "identity",
          filterOptions: {
            enabled: true,
            placeholder: "Pesquisar CPF/CNPJ",
          },
        },
        {
          label: "Ciclo",
          field: "cycle_name",
          filterOptions: {
            enabled: true,
            placeholder: "Pesquisar Ciclo",
          },
        },
        {
          label: "Filial",
          field: "fommento_name",
          filterOptions: {
            enabled: true,
            placeholder: "Pesquisar Filial",
          },
        },
        {
          label: "Fomento",
          field: "fommento_account",
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: "Pesquisar Fomento",
          },
        },
        {
          label: "Valor Bruto",
          field: "requested_amount",
        },
        {
          label: "Valor Líquido",
          field: "released_amount",
        },
        {
          label: "Total Receita",
          field: "total_tax_value",
        },
        {
          label: "A Receber Whitelabel",
          field: "whitelabel_split",
        },
        {
          label: "A Receber MoneyCloud",
          field: "moneycloud_split",
        },
        {
          label: "Pagamento",
          field: "pay_day",
        },
      ],
      ptBR: ptBR,
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      page: 1,
      limit: 10,
      loadingExcel: false,
      loadingPdf: false,
      allDatas: null,
    };
  },
  computed: {
    endpoint() {
      const filters = [];

      if (this.table.filters.started_at && this.table.filters.finished_at) {
        filters.push({
          field: "credited_at",
          operator: "btw",
          value: [
            startOfDay(this.table.filters.started_at),
            addDays(startOfDay(this.table.filters.finished_at), 1),
          ],
        });
      }

      return {
        baseUrl: "/bonus/report",
        params: {
          filters,
          page: 1,
          limit: 10,
          orders: {
            credited_at: "desc",
          },
        },
      };
    },
  },
  created() {
    if(!['Controller', 'Back Office'].includes(this.userInfo.role)) {
      permissionRedirect("acl.hidden");
    }
  },
  methods: {
    formatIdentity,
    formatMoney,
    formatDate,
    formatDateSubHours,
    onSearch() {
      this.page = 1;
      this.fetchTableData();
    },
    goBack() {
      this.$router.push(`/hub-bonus-advance`);
    },
    async download(type) {
      type === 'pdf' ? this.loadingPdf = true : this.loadingExcel = true;

      let balances = {
        requestedAmount: 0,
        releasedAmount: 0,
        totalTaxValue: 0,
        whitelabelSplit: 0,
        moneycloudSplit: 0,
      };

      const filters = [];

      if (this.table.filters.started_at && this.table.filters.finished_at) {
        filters.push({
          field: "credited_at",
          operator: "btw",
          value: [
            startOfDay(this.table.filters.started_at),
            addDays(startOfDay(this.table.filters.finished_at), 1),
          ],
        });
      }

      await this.$http.get('/bonus/report', {
        params: {
          orders: {
            credited_at: 'asc',
          },
          filters,
          limit: this.totalRecords,
        },
      }).then((data) => {
        this.allDatas = data?.data?.data?.map((row) => {
          const item = {};

          item.credited_at = formatDateSubHours(row.credited_at) || 'N/A';
          item.person_name = row.person_name;
          item.identity = formatIdentity(row?.identity) || 'N/A';
          item.cycle_name = row?.cycle_name || 'N/A';
          item.fommento_name = row?.fommento?.name || 'N/A';
          item.fommento_account = row?.fommento?.account_number || 'N/A';

          item.requested_amount = formatMoney(row.requested_amount);
          item.released_amount = formatMoney(row.released_amount);
          item.total_tax_value = formatMoney(row.total_tax_value);
          item.whitelabel_split = formatMoney(row.whitelabel_split);
          item.moneycloud_split = formatMoney(row.moneycloud_split);
          item.pay_day = formatDateSubHours(row.pay_day) || 'N/A';

          balances.requestedAmount += row?.requested_amount || 0;
          balances.releasedAmount += row?.released_amount || 0;
          balances.totalTaxValue += row?.total_tax_value || 0;
          balances.whitelabelSplit += row?.whitelabel_split || 0;
          balances.moneycloudSplit += row?.moneycloud_split || 0;

          return item;
        });

        type === 'pdf' ? 
          this.gerarPDF(balances) : 
          this.gerarExcel(balances);

      })
      .catch((err) => {
        console.log(err);
        this.loadingExcel = false;
        this.loadingPdf = false;
      });
    },
    async gerarPDF(data) {
      const columns = [
        { title: 'Creditado Em', dataKey: 'credited_at' },
        { title: 'Titular', dataKey: 'person_name' },
        { title: 'CPF / CNPJ', dataKey: 'identity' },
        { title: 'Ciclo', dataKey: 'cycle_name' },
        { title: 'Filial', dataKey: 'fommento_name' },
        { title: 'Fomento', dataKey: 'fommento_account' },

        { title: 'Valor Bruto', dataKey: 'requested_amount' },
        { title: 'Valor Líquido', dataKey: 'released_amount' },
        { title: 'Total Receita', dataKey: 'total_tax_value' },
        { title: 'A Receber Whitelabel', dataKey: 'whitelabel_split' },
        { title: 'A Receber MoneyCloud', dataKey: 'moneycloud_split' },
        { title: 'Pagamento', dataKey: 'pay_day' },
      ];

      let body = await this.allDatas;
      let orientacao = '';
      let doc = gerarDocPdf({ orientacao });

      doc = gerarTablePdf({
        doc,
        columns,
        columnStyles: {
					0: { cellWidth: 25 },
					2: { cellWidth: 25 },
					5: { cellWidth: 20 },
					6: { cellWidth: 20 },
					7: { cellWidth: 20 },
					8: { cellWidth: 20 },
					9: { cellWidth: 20 },
					10: { cellWidth: 20 },
          11: { cellWidth: 25 },
				},
        body,
      });

      doc = gerarTablePdf({
        doc,
        showHead: 'never',
        columnStyles: {
            europe: { halign: 'center' },
            text: { halign: 'right', minCellWidth: 80 },
            s: { halign: 'center' },
        },
        columns: [
            { title: 'Title I', dataKey: 'requestedAmount' },
            { title: 'Title II', dataKey: 'releasedAmount' },
            { title: 'Title III', dataKey: 'totalTaxValue' },
            { title: 'Title IV', dataKey: 'whitelabelSplit' },
            { title: 'Title V', dataKey: 'moneycloudSplit' },
        ],
        body: [
          {
            requestedAmount: "Valor Bruto R$ " + formatMoney(data.requestedAmount),
            releasedAmount: "Valor Líquido R$ " + formatMoney(data.releasedAmount),
            totalTaxValue: "Total Receita R$ " + formatMoney(data.totalTaxValue),
            whitelabelSplit: "A Receber Whitelabel R$ " + formatMoney(data.whitelabelSplit),
            moneycloudSplit: "A Receber MoneyCloud R$ " + formatMoney(data.moneycloudSplit),
          },
        ],
      });

      doc = gerarDocInfo({
        doc,
        title: `Antecipação de Bônus - ${process.env.VUE_APP_TITLE}`,
        orientacao,
      });

      salvarDocPdf({ doc, filename: 'antecipação_de_bônus_' });
      this.loadingPdf = false;
      this.allDatas = null;
    },
    gerarExcel(data) {
      const adtStyle = {
        font: { bold: true },
        fill: {
          patternType: 'solid',
          fgColor: {
            rgb: 'fff5f5f5',
          },
          bgColor: {
            rgb: 'fff5f5f5',
          },
        },

        border: {
          top: {
            style: 'thin',
            color: { rgb: 'ffcecece' },
          },
          right: {
            style: 'thin',
            color: { rgb: 'ffcecece' },
          },
          bottom: {
            style: 'thin',
            color: { rgb: 'ffcecece' },
          },
          left: {
            style: 'thin',
            color: { rgb: 'ffcecece' },
          },
        },
      };

      excelGenerator(
          'Antecipação de Bônus',
          'Antecipação de Bônus',
          'Antecipação de Bônus',
          [[]],
          [
            [
              {
                v: `Total:`,
                t: 's',
                s: {
                  alignment: { horizontal: 'left' },
                  ...adtStyle,
                },
              },
              {},
              {},
              {},
              {},
              {},
              {
                v: `R$ ${formatMoney(data.requestedAmount)}`,
                t: 's',
                s: {
                  alignment: { horizontal: 'left' },
                  ...adtStyle,
                },
              },
              {
                v: `R$ ${formatMoney(data.releasedAmount)}`,
                t: 's',
                s: {
                  alignment: { horizontal: 'left' },
                  ...adtStyle,
                },
              },
              {
                v: `R$ ${formatMoney(data.totalTaxValue)}`,
                t: 's',
                s: {
                  alignment: { horizontal: 'left' },
                  ...adtStyle,
                },
              },
              {
                v: `R$ ${formatMoney(data.whitelabelSplit)}`,
                t: 's',
                s: {
                  alignment: { horizontal: 'left' },
                  ...adtStyle,
                },
              },
              {
                v: `R$ ${formatMoney(data.moneycloudSplit)}`,
                t: 's',
                s: {
                  alignment: { horizontal: 'left' },
                  ...adtStyle,
                },
              },
              {},
            ],
          ],
          [
            'Creditado Em',
            'Titular',
            'CPF / CNPJ',
            'Ciclo',
            'Filial',
            'Fomento',
            'Valor Bruto',
            'Valor Líquido',
            'Total Receita',
            'A Receber Whitelabel',
            'A Receber MoneyCloud',
            'Pagamento',
          ],
          this.allDatas,
      );

      this.loadingExcel = false;
      this.allDatas = null;
    },
  },
};

</script>